// import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// import { socket } from 'api';
import { useVideoUrls, useRackState } from 'libs/hooks';
import { PaymentMean, ModeSelector, RackState } from 'libs/ui';
import withRackLogic from '../withRackLogic';
import { RackVideos } from './rack-videos/rack-videos';
import { GateControl } from './gate-control/gate-control';
import { RackActions } from './rack-actions/rack-actions';
import { RackWrapper } from '../styledComponents';
import { ControlBlocks, StyledControlPanel, ControlBlockHeader } from './rack.styled';

const RackControl = (props) => {
  const { id, sendControlMsg, status, data } = props;
  // console.log("status", status);
  const { t } = useTranslation();
  const mode = status?.mode;
  useRackState({ mode, sendControlMsg, id });
  const { cams } = useVideoUrls({ sendControlMsg, streams: status?.streams, mode, id });

  const rightControl = window.haveRight('mnemo.rack_control');
  const modeOk = mode;
  const offline = modeOk === 'offline';
  let cl = '';
  let cl1 = offline ? 'offline' : '';
  let cl2 = offline ? 'offline1' : '';
  if (!modeOk) {
    cl += ' loading';
    cl1 += ' loading';
    cl2 += ' offline1';
  }

  // const printTicket = () => {
  //   const msg = {
  //     id: this.props.id,
  //     data: '{"message": "print ticket"}',
  //     user_id: window.user.getId(),
  //   };
  //   socket.emit('message', {
  //     jsonrpc: '2.0',
  //     id: '1',
  //     method: 'control.send',
  //     params: msg,
  //   });
  // };
  // console.log('cams', cams);

  return (
    <RackWrapper className={cl}>
      <RackVideos cams={cams} id={id} cl={cl2} />

      <StyledControlPanel className={cl1} $status={t('clarifications.отключен')}>
        <PaymentMean id={id} />

        <RackActions id={id} sendControlMsg={sendControlMsg} />

        <ModeSelector type="rack" id={id} sendControlMsg={sendControlMsg} />

        <ControlBlocks>
          <GateControl
            sendControlMsg={sendControlMsg}
            items={[
              {
                title: t('buttons.Разрешить проезд'),
                icon: 'open-gate.png',
                msg: 'allow_from_main',
                disabled: !rightControl,
                withConfirm: true,
                confirmTop: '84px',
                color: 'blue',
                className: 'big',
              },
              {
                title: t('buttons.Открыть'),
                icon: 'open-gate.png',
                msg: 'open_main',
                disabled: !rightControl,
                withConfirm: true,
                confirmTop: '46px',
                color: 'blue',
              },
              { title: t('buttons.Закрыть'), icon: 'close-gate.png', msg: 'close_main', disabled: !rightControl, color: 'red' },
            ]}
          />

          {data.barriersCount === 2 && (
            <>
              <ControlBlockHeader>{t('windows.Шлюз')}</ControlBlockHeader>
              <GateControl
                sendControlMsg={sendControlMsg}
                items={[
                  {
                    title: t('buttons.Выпустить'),
                    icon: 'open-gate.png',
                    msg: 'allow_from_gateway',
                    disabled: !rightControl,
                    color: 'blue',
                    className: 'big',
                  },
                  {
                    title: t('buttons.Открыть'),
                    icon: 'open-gate.png',
                    msg: 'open_gateway',
                    disabled: !rightControl,
                    color: 'blue',
                  },
                  { title: t('buttons.Закрыть'), icon: 'close-gate.png', msg: 'close_gateway', disabled: !rightControl, color: 'red' },
                ]}
              />
            </>
          )}
        </ControlBlocks>
      </StyledControlPanel>

      <RackState sendControlMsg={sendControlMsg} id={id} offline={offline} />
    </RackWrapper>
  );
};

export default withRackLogic(RackControl, {
  type: 'rack',
  reloadType: 'reboot controller',
});
